import { Guid } from '../guid';
import { MapperBase } from '../../utilities/mapper-base';
import { LifeCycle } from '../lifecycle.model';
import { AccountResource } from '../resource/account.resource';
import { Account } from '../ui/account.model';
import { CaseResourceToLexbeCaseMapper } from './case-resource-to-lexbe-case.mapper';
import { UserResourceToUserMapper } from './user-resource-to-user.mapper';

export class AccountResourceToAccountMapper extends MapperBase<AccountResource, Account> {
	map(source: AccountResource): Account {
		const dest = new Account();
		const userMapper = new UserResourceToUserMapper();
		const caseMapper = new CaseResourceToLexbeCaseMapper();
		dest.accountId = source?.accountId ? source.accountId.toLowerCase() : Guid.Empty;
		dest.accountName = source?.accountName ?? '';
		if (source?.lifeCycle)
			dest.lifeCycle = LifeCycle.Deleted;
		else
			dest.lifeCycle = LifeCycle.Active;
		dest.accountComments = source?.accountComments ?? '';
		dest.accountLogoFilename = source?.accountLogoFilename ?? '';
		dest.message = source?.message ?? '';
		dest.crmUrl = source?.crmUrl ?? '';
		dest.type = source?.type ?? '';
		dest.docSize = source?.docSize ?? -1;
		dest.indexSize = source?.indexSize ?? -1;
		dest.productionJobSize = source?.productionJobSize ?? -1;
		dest.downloadSize = source?.downloadSize ?? -1;
		dest.archiveJobSize = source?.archiveJobSize ?? -1;
		dest.isHibernated = source?.isHibernated ?? false;
		dest.users = userMapper.mapCollection(source?.users);
		dest.cases = caseMapper.mapCollection(source?.cases);
		return dest;
	}

}
